import { combineReducers } from 'redux';
// Import reducers
import table from './activity_panel_reducer';
import form from './activity_form_reducer';

export default combineReducers({
	table,
	form
});
